export default {
  setLegacy: (state, payload) => {
    state.legacy = [...state.legacy,...payload];
  },
  setMeta(state, payload) {
    state.meta = payload;
  },
  increasePage: (state) => {
    state.page++;
  },
  allLegaciesLoaded: (state, payload) => {
    state.allLegaciesLoaded = payload;
  },
  resetLegacyDetails: (state) => {
    state.legacyDetails = null;
  },
  noResult: (state, payload) => {
    state.noResult = payload;
  },
  reset: (state, ) => {
    state.page = 1;
    state.legacy=[];
    state.meta = null;
    state.allLegaciesLoaded=false;
  },
  setLegacyDetails(state, payload) {
    state.legacyDetails = payload;
  }
};
